import { fadeUpTitle } from './module/fadeUpTitle.js';
fadeUpTitle();

import { flowSlider } from './module/flowSlider.js';
flowSlider();
